import React from "react";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import Modal from "@/components/modal";
import { useDeleteAdvertisementMutation } from "@/app/features/advertisement/advertisementApiSlice";
import { toast } from "sonner";

const CarDetails = styled(Box)`
  overflow-y: auto;
  height: 300px;
`;

function CarRow({ name, value }) {
  return (
    <Grid container mb={1}>
      <Grid item xs={12} sm={2}>
        {name}
      </Grid>

      <Grid item xs={12} sm={10}>
        {value}
      </Grid>
    </Grid>
  );
}

export default function AdvertismentModal({
  open,
  handleClose,
  selectedAdvertisement,
}) {
  const [deletePost, { isLoading }] = useDeleteAdvertisementMutation();

  console.log(selectedAdvertisement);

  const handleDelete = async () => {
    try {
      await deletePost(selectedAdvertisement.id);
      handleClose();
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
        }}
      >
        Are you sure you want to delete {selectedAdvertisement.adText} ?
      </Typography>

      <CarDetails>
        <CarRow name="Ad Name" value={selectedAdvertisement.adText} />
        <CarRow
          name="Web Link"
          value={
            <a
              href={selectedAdvertisement.adLink}
              target="_blank"
              rel="noreferrer"
            >
              {selectedAdvertisement.adLink}
            </a>
          }
        />
        <CarRow name="State" value={selectedAdvertisement.state} />
        <CarRow
          name="Status"
          value={selectedAdvertisement.status ? "Active" : "Inactive"}
        />

        <CarRow
          name="Desktop View"
          value={
            <img
              src={` https://thebeep-au.syd1.cdn.digitaloceanspaces.com/advertisement/${selectedAdvertisement.adDesktopBanner}`}
              alt={selectedAdvertisement.adText}
              width={400}
              height={200}
              style={{
                objectFit: "contain",
              }}
            />
          }
        />

        <CarRow
          name="Mobile View"
          value={
            <img
              src={` https://thebeep-au.syd1.cdn.digitaloceanspaces.com/advertisement/${selectedAdvertisement.adMobileBanner}`}
              alt={selectedAdvertisement.adText}
              width={400}
              height={200}
              style={{
                objectFit: "contain",
              }}
            />
          }
        />

        <CarRow
          name="Created On"
          value={moment(selectedAdvertisement.createdAt).format("MMMM Do YYYY")}
        />
      </CarDetails>

      <Stack direction="row" alignItems="center" justifyContent="center" mt={2}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleDelete}
          disabled={isLoading}
        >
          Delete
        </Button>
      </Stack>
    </Modal>
  );
}
